var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89435 0.294922L3.86094 1.42433H2.07082C1.44964 1.42433 0.941406 1.93257 0.941406 2.55375V9.33022C0.941406 9.95139 1.44964 10.4596 2.07082 10.4596H11.1061C11.7273 10.4596 12.2355 9.95139 12.2355 9.33022V2.55375C12.2355 1.93257 11.7273 1.42433 11.1061 1.42433H9.31599L8.28258 0.294922H4.89435ZM6.58846 8.76551C5.02988 8.76551 3.76494 7.50057 3.76494 5.94198C3.76494 4.38339 5.02988 3.11845 6.58846 3.11845C8.14705 3.11845 9.41199 4.38339 9.41199 5.94198C9.41199 7.50057 8.14705 8.76551 6.58846 8.76551Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cd35654c4f81f514ba565144627218ab.svg";
export { ForwardRef as ReactComponent };